
export const EXIST_LOCAL_STORAGE = {
    AUTHTOKEN: 'AuthToken',
    REFRESH_TOKEN: 'refreshToken',
    USER_DETAIL: 'userDetail',
    USERNAME: 'USERNAME',
    USER_ID: 'userId',
    IS_KEEP_ME: 'isKeepMe',
    THEME_MODE: 'themeMode',
    EXPIRATION_TIME: 'expiration',
    API_KEY: 'apiKey',
    FULL_NAME: 'fullName',
    USER_IMG: 'userImg',
    ROLE: 'role',
    BOND_DATA: 'bondData',
    BOND_FILTER_OBJ: 'bondfILTER',
    USER_TYPE: 'userType',
    ISSTAYLOGIN: 'isStayLogin',
    SITE_VISITOR_ID: 'siteVisitorId',
    IS_BOUNCED: 'is_bounced',
};

export const USER_TYPE = [
    { value: 1, label: 'Admin' },
    { value: 2, label: 'User' },
];

// Check if the environment variables are defined
if (!process.env.NODE_ENV) throw new Error('NODE_ENV is not defined in .env file');
if (!process.env.NEXT_PUBLIC_BASE_URL) throw new Error('NEXT_PUBLIC_BASE_URL is not defined in .env file');
if (!process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY) throw new Error('NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not defined in .env file');

export const isProd = process.env.NODE_ENV === 'production';
export const baseURL = process.env.NEXT_PUBLIC_BASE_URL;
export const baseURLImg = process.env.NEXT_PUBLIC_BASE_URL.replace('api', '');
